import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FallSmoothIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M11.9999 3C2.22995 3 0.0899477 19.19 -5.22574e-05 19.88C-0.0700523 20.43 0.319948 20.93 0.869948 21C1.41995 21.06 1.91995 20.68 1.98995 20.13C2.00995 19.98 3.98995 5.01 11.9999 5.01C20.0099 5.01 21.9899 19.98 22.0099 20.13C22.0799 20.68 22.5799 21.06 23.1299 21C23.6799 20.93 24.0699 20.43 23.9999 19.88C23.9099 19.19 21.7799 3 12.0099 3H11.9999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FallSmoothIcon.displayName = 'FallSmoothIcon';
